import React from "react";
import { Box } from "@mui/material";
import Sidebar from "./sidebar/Sidebar";
import Navbar from "./Navbar";
const drawerWidth = 200;

const AdminDashboardLayout = (props) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return (
    <>
      <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#F8FAFC' }}>
        <Sidebar
          mobileOpen={mobileOpen}
          isAgentPanel={true}
          handleDrawerToggle={handleDrawerToggle}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: { md: `calc(100% - ${drawerWidth}px)` },
            // ml: { md: `${drawerWidth}px` },
            // px: { xs: 1, md: 1 },
            p: 1,
            transition: 'all 0.3s ease'
          }}
        >
          <Navbar
            headingTitle={props.navTitle}
            headingSubtitle={props.navSubTitle}
            handleDrawerToggle={handleDrawerToggle}
          />
          <Box sx={{ mt: 2 }}>
            {props.children}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AdminDashboardLayout;
